import { htmlIded, htmlTagged } from './fun-js-lib/html'

export function getLogPageForm () {
  console.log("Getting log page form")
  let form = new FormData()
  htmlTagged(htmlIded('page-data-form'), 'input')
    .forEach(input => console.log("Element inspected: ", input))
  htmlTagged(htmlIded('page-data-form'), 'input')
    .forEach(input => maybeAppendElement(form, input))
  if(htmlIded('measurement-content')) {
    appendContents(form, htmlIded('measurement-content'), 'measurement_content')
    htmlTagged(htmlIded('page-data-form'), 'select')
    .forEach(select => maybeAppendElement(form, select))
  }else {

    htmlTagged(htmlIded('page-data-form'), 'textarea')
      .forEach(textarea => maybeAppendElement(form, textarea))

    form.append('mechanization[]', '')
    form.append('mechanization[]', '')
  }
  return form
}

/**
 * @param {FormData} form 
 * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} element
 */
function maybeAppendElement (form, element) {
  let name = element.getAttribute('name')
  console.log("Name ", name);
  if (name !== null && name !== '' && name !== 'files[]') {
    let value = element.value
    form.append(name, value)
  }
}

/**
 * @param {FormData} form
 * @param {HTMLElement} element
 * @param {string} name
 */
function appendContents(form, element, name){
  form.append(name, element.innerHTML);
}

export function getFormUrl () {
  console.log("Getting form url: ", htmlIded('page-data-form').getAttribute('action'))
  return htmlIded('page-data-form').getAttribute('action')
}